import { useEffect } from "react"

import { useAppState } from "../../context/appStateContext"
import { PurchasProvider } from "../../context/purchaseContext"
import {
  UltimateAlertsProvider,
  useUltimateAlerts,
} from "../../context/ultimateAlertsContext"
import useStrings from "../../localization/useStrings"
import styles from "./ExpirationModernPaywall.module.scss"

import { useExpiration } from "../../context/expirationContext"
import ExpirationComparePlansButton from "../ExpirationPaywall/ExpirationComparePlansButton/ExpirationComparePlansButton"
import Svg from "../../utils/svg"
import native from "../../native/native"
import Terms from "../../components/Terms/Terms"
import TwoStepPaywall from "../TwoStepPaywall/TwoStepPaywall"
import ExpirationModernWarmup from "./ExpirationModernWarmup/ExpirationModernWarmup"
import UltimateSubfeaturesPopups from "../../components/UltimateSubfeaturesPopups/UltimateSubfeaturesPopups"
import ComparePlansSheet from "../../components/ComparePlansSheet/ComparePlansSheet"
import UltimateBackground from "../../components/UltimateBackground/UltimateBackground"
import FeatureList from "../../components/FeatureList/FeatureList"
import ExpirationModernPricingSelection from "./ExpirationModernPricingSelection/ExpirationModernPricingSelection"
import images from "../../utils/images"

const ExpirationModernPaywall = () => {
  const { actions } = useAppState()

  useEffect(() => {
    actions.setFooterInsetColor("var(--subscription-background)")
    actions.setIgnoreFooterInset(true)
  }, [])

  return (
    <PurchasProvider>
      <UltimateAlertsProvider>
        <TwoStepPaywall
          MainPage={<Content />}
          WarmupPage={<ExpirationModernWarmup />}
        />
        <UltimateSubfeaturesPopups />
        <ComparePlansSheet />
      </UltimateAlertsProvider>
    </PurchasProvider>
  )
}

const Content = () => {
  const expirationState = useExpiration().state
  const { actions } = useAppState()
  const comparePlanActions = useUltimateAlerts().actions

  useEffect(() => {
    comparePlanActions.setShowBasicTitle(true)
  })

  if (expirationState.isUltimate) {
    document.documentElement.setAttribute("expiration-selection", "ultimate")
  } else {
    document.documentElement.setAttribute("expiration-selection", "")
  }

  return (
    <div className={styles.scrollableList}>
      <div className={styles.backgroundImageContainer}>
        <div
          className={`${images.expiration.background.class} ${styles.backgroundImage}`}
        />
      </div>
      <div className={styles.mainContent}>
        <Header />
        <ExpirationModernPricingSelection />
        <div style={{ marginTop: 50 }} />
        <FeatureList lightContent useModernExpirationStyle />
      </div>
      {expirationState.isUltimate && <UltimateBackground forceVisible />}
      <Footer />
    </div>
  )
}

const Header = () => {
  const expirationState = useExpiration().state
  const isUltimate = expirationState.canToggleUltimate == false
  const strings = useStrings().expiration
  const comparePlans = useStrings().comparePlans.title
  const title = isUltimate ? strings.titleUltimate : strings.titlePremium
  const subtitle = isUltimate
    ? strings.subtitleUltimate
    : strings.subtitlePremium
  const showComparePlans = useUltimateAlerts().actions.setShowComparePlansSheet

  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerIcon}>
        {expirationState.isUltimate ? (
          <Svg.UltimateBadge className={styles.svgIcon} />
        ) : (
          <Svg.PremiumBadge className={styles.svgIcon} />
        )}
      </div>
      <label className={styles.title}>{title}</label>
      <label className={styles.subtitle}>{subtitle}</label>
      <button
        className={styles.comparePlans}
        onClick={() => {
          showComparePlans(true)
        }}
      >
        {comparePlans}
      </button>
    </div>
  )
}

const Footer = () => {
  const strings = useStrings().expiration

  return (
    <div className={styles.footerContainer}>
      <div className={styles.footerContentContainer}>
        <button
          className={styles.basicButton}
          onClick={() => {
            native.postNativeEvent("close")
          }}
        >
          {strings.basicButton}
        </button>
        <div className={styles.basicContainer}>
          <label className={styles.basicTitle}>{strings.basicTitle}</label>
          <label className={styles.basicDescription}>
            {strings.basicDescription}
          </label>
        </div>
        <Terms lightContent />
        <div style={{ height: 32 }} />
      </div>
    </div>
  )
}

export default ExpirationModernPaywall
